import { render, staticRenderFns } from "./SupplierEventDetails.vue?vue&type=template&id=1600529e&scoped=true&"
import script from "./SupplierEventDetails.vue?vue&type=script&lang=ts&"
export * from "./SupplierEventDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierEventDetails.vue?vue&type=style&index=0&id=1600529e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600529e",
  null
  
)

export default component.exports